
import { defineComponent, PropType, computed } from '@vue/runtime-core'
import { useStore } from 'vuex'
import Button from '@/components/elements/Button.vue'
import FavoriteButton from '@/components/elements/FavoriteButton.vue'
import { ActionHistory } from '@/types/StoreState'

export default defineComponent({
  name: 'hospitalContactBtn',

  components: {
    Button,
    FavoriteButton
  },

  props: {
    type: {
      type: String as PropType<'default' | 'latter'>,
      default: 'default'
    },
    position: {
      type: String as PropType<'main' | 'side'>,
      default: 'main'
    },
    id: {
      type: Number,
      require: true
    },
    sTrainingId: {
      type: Number,
      default: 0
    },
    sTrainingName: {
      type: String,
      default: ''
    },
    paidFlg: {
      type: Boolean,
      default: false
    },
    isHorizontal: {
      type: Boolean,
      default: false
    },
    isVertical: {
      type: Boolean,
      default: false
    }
  },

  setup(props, { emit }) {
    const store = useStore()

    const outputTitle = computed(() => {
      if (props.type === 'default') return '初期研修への申し込み'
      if (props.sTrainingName)
        return `専門研修「${props.sTrainingName}」への申し込み`
      return ''
    })

    const visitApplicationUrl = computed(() => {
      return props.type === 'default'
        ? `/visit_application/${props.id}/input`
        : `/visit_application_latter/${props.sTrainingId}/input`
    })

    const documentRequestUrl = computed(() => {
      return props.type === 'default'
        ? `/document_request/${props.id}/input`
        : `/document_request_latter/${props.sTrainingId}/input`
    })

    const isFavorite = computed(() => {
      if (!store.state.isLogin) return false

      if (props.type === 'default') {
        return store.state.userInfo.favorite_history.some(
          (el: ActionHistory) => el.hospital_id === Number(props.id)
        )
      }
      if (props.type === 'latter') {
        return store.state.userInfo.s_favorite_history.some(
          (el: ActionHistory) => el.s_training_id === Number(props.sTrainingId)
        )
      }
      return false
    })

    const clickFavorite = () => {
      if (props.type === 'default') return emit('click-favorite')

      if (props.type === 'latter') {
        if (isFavorite.value) {
          store.dispatch('removeFavorite', {
            id: Number(props.id),
            sId: Number(props.sTrainingId)
          })
        } else {
          store.dispatch('addFavorite', {
            id: Number(props.id),
            sId: Number(props.sTrainingId)
          })
        }
      }
    }

    return {
      outputTitle,
      visitApplicationUrl,
      documentRequestUrl,
      isFavorite,
      clickFavorite
    }
  }
})
